import { z } from 'zod';

export const goldGamesFreeSpinFiltersSchema = z.object({
  playerId: z.string().catch(''),
  campaign: z.string().max(120).catch(''),
});

export const goldGamesFreeSpinsSchema = z
  .object({
    name: z.string().trim().min(1, 'Campaign name is required.').max(120),
    brandId: z.string().min(1, 'Provider is required.'),
    gameId: z.string().min(1, 'Game is required.'),
    presetId: z.string().min(1, 'Select an available Gold Games preset.'),
    playerIds: z.array(z.string()).min(1, 'Select at least one player.').max(100, 'Select no more than 100 players.'),
    startsAt: z.string().refine((value) => Number.isFinite(Date.parse(value)), 'Start date is required.'),
    endsAt: z.string().refine((value) => Number.isFinite(Date.parse(value)), 'End date is required.'),
  })
  .refine((data) => Date.parse(data.endsAt) > Date.parse(data.startsAt), {
    message: 'End must be after start.',
    path: ['endsAt'],
  });

export type GoldGamesFreeSpinsFormData = z.infer<typeof goldGamesFreeSpinsSchema>;
